<template>
  <div class="form-wrapper">
    <div class="form-fields-wrapper">
      <base-form-field
        v-model="personalInfo.dateOfBirth"
        :schema="schema.dateOfBirth"
        :validateOnChange="true"
      />
    </div>
    <div class="form-buttons-wrapper"><next-button @click="submit" text="Submit" /></div>
  </div>
</template>
<script setup lang="ts">
import { $api } from "@/services/api";
import { reactive, ref } from "vue";
import type { FieldSchema, FormSchema } from "@/models/form";
import BaseFormField from "@/components/shared/BaseFormField.vue";
import NextButton from "@/components/shared/NextButton.vue";
import useValidation from "@/use/validation";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import type { StipulationInputRequest } from "@/models/api";

interface Props {
  applicant: Applicant;
  stip: Stipulation;
}

const props = withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
  (e: "success", updatedStip: Stipulation): void;
}>();

const { validateForm } = useValidation();

let personalInfo = ref({} as any);

const submittingData = ref<boolean>(false);

const schema = reactive<FormSchema>({
  dateOfBirth: {
    name: "dateOfBirth",
    type: "date",
    subtype: "dob",
    label: "Date of Birth",
    required: true,
    errorMessage: "Date of Birth is required.",
  } as FieldSchema,
} as FormSchema);

async function submit() {
  submittingData.value = true;
  const valid = validateForm(schema, personalInfo.value);
  if (valid) {
    const request = {
      applicationStipulationId: props.stip?.id,
      applicationId: props?.stip?.applicationId,
      dobInput: { dateOfBirth: personalInfo.value?.dateOfBirth },
    } as StipulationInputRequest;

    const response = await $api.applications.addStipInput(props?.stip?.applicationId, request);

    if (response?.id && response?.id > 0) {
      // updates stip status to pending
      let updatedDateOfBirthVerificationStip = props.stip;
      updatedDateOfBirthVerificationStip.stipulationStatusId = response.stipulationStatusId;
      updatedDateOfBirthVerificationStip.stipulationStatusName = response.stipulationStatusName;
      
			emit("success", updatedDateOfBirthVerificationStip);

      submittingData.value = false;
    } else {
      submittingData.value = false;
    }
  } else {
    submittingData.value = false;
  }
}
</script>
<style scoped>
.form-wrapper .form-fields-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1em;
}
.form-wrapper .form-buttons-wrapper {
  margin-top: 1rem;
}
</style>
